import {
  CREATE_ACCOUNT_CALLBACK,
  NHS_ONBOARDING_PATH,
} from 'config/deepLinking';
import { PLATGEN_ONBOARDING_URL } from 'config/envVars';

const openNHSCreateAccountBrowser = async (): Promise<{
  deepLinkReceived: boolean;
  isError?: boolean;
  token?: string | null;
}> => {
  // Use the configured onboarding origin verbatim (must match the Auth0 redirect_uri).
  const url = `${PLATGEN_ONBOARDING_URL}${NHS_ONBOARDING_PATH}?redirect_url=${encodeURIComponent(
    CREATE_ACCOUNT_CALLBACK
  )}`;
  window.location.href = url;
  return { deepLinkReceived: false };
};

export { openNHSCreateAccountBrowser };
